package com.ai.mitra.domain.use_cases

import com.ai.mitra.domain.model.Role
import com.ai.mitra.domain.respository.GeminiRepository
import org.koin.core.component.KoinComponent


class InsertMessageUseCase(private val geminiRepository: GeminiRepository) : KoinComponent {
    suspend fun insertMessage(
        messageId: String,
        groupId: String,
        text: String,
        images: List<ByteArray>,
        participant: Role,
        isPending: Boolean
    ) {
        geminiRepository.insertMessage(messageId, groupId, text, images, participant, isPending)
    }

}